export type IDownloadableFile = {
  filename: string;
  type: string;
  data: Blob;
};

export const DownloadableFileDefault: IDownloadableFile = {
  filename: 'NoDeviceNameSet.txt',
  type: 'txt',
  data: new Blob(),
};


export type IDownloadableCheck = {
  numDevicesInKem: number;
  invalidDevices: string;
};

export const DownloadableCheckDefault: IDownloadableCheck = {
  numDevicesInKem: 0,
  invalidDevices: '',
};